export const initRegulatoryPopup = () => {
  const openButtons = document.querySelectorAll('.js-regulatory-open');
  const popup = document.querySelector('.js-regulatory-popup');
  const closeButtons = popup ? popup.querySelectorAll('.js-regulatory-close') : [];
  const dialog = popup ? popup.querySelector('.js-regulatory-dialog') : null;
  let activeOpenButton = null;

  if (!openButtons.length || !popup) {
    return;
  }

  const openRegulatoryPopup = (button) => {
    activeOpenButton = button;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-regulatory-popup-open');

    openButtons.forEach((openButton) => {
      openButton.setAttribute('aria-expanded', String(openButton === button));
    });

    if (dialog) {
      dialog.focus();
    }
  };

  const closeRegulatoryPopup = () => {
    if (popup.hidden) {
      return;
    }

    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-regulatory-popup-open');

    openButtons.forEach((openButton) => {
      openButton.setAttribute('aria-expanded', 'false');
    });

    if (activeOpenButton) {
      activeOpenButton.focus();
    }
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', () => openRegulatoryPopup(button));
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeRegulatoryPopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeRegulatoryPopup();
    }
  });
};
